
import TicketStar from "../../../assets/filled/TicketStar.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TicketStarIcon({ className, dataTestid = "TicketStarIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TicketStar data-testid={dataTestid} className={classes} {...rest} />
  );
}
